import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem } from '@blueprintjs/core';
import { TlsProxy } from 'data/tlsProxy/tlsProxy.types';
import { TlsProxyMenuActionsType } from 'routes/TlsProxy/TlsProxy.types';

interface Props {
  data: TlsProxy,
  disabled: boolean;
  context: {
    onActionMenuItemClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    props: {
      showActionMenuItem: boolean,
      hasPrivilegeToCreateNew: boolean;
      hasPrivilegeToDelete: boolean;
      hasPrivilegetoView: boolean;
    }
  };
}

const TlsProxyListMenu: FunctionComponent<Props> = ({
  data,
  disabled,
  context: {
    onActionMenuItemClick,
    props: {
      showActionMenuItem,
      hasPrivilegetoView,
      hasPrivilegeToCreateNew,
      hasPrivilegeToDelete,
    },
  },
}: Props) => {
  const { t } = useTranslation();

  return (
    <Menu>
      {hasPrivilegetoView && showActionMenuItem && (
        <MenuItem
          id={TlsProxyMenuActionsType.View}
          onClick={onActionMenuItemClick}
          disabled={disabled}
          text={t('securityGateway.grid.view')}
        />
      )}
      {hasPrivilegeToCreateNew && showActionMenuItem && (
        <MenuItem
          id={TlsProxyMenuActionsType.Edit}
          onClick={onActionMenuItemClick}
          disabled={disabled}
          text={t('securityGateway.grid.edit')}
        />
      )}
      {hasPrivilegeToCreateNew && showActionMenuItem && (
        <MenuItem
          id={TlsProxyMenuActionsType.Copy}
          onClick={onActionMenuItemClick}
          disabled={disabled}
          text={t('securityGateway.grid.copy')}
        />
      )}
      {hasPrivilegeToDelete && showActionMenuItem && (
        <MenuItem
          id={TlsProxyMenuActionsType.Delete}
          onClick={onActionMenuItemClick}
          disabled={disabled}
          text={t('securityGateway.grid.delete')}
        />
      )}
    </Menu>
  );
};

export default TlsProxyListMenu;
